import { postRequest } from '../../../shared/utils';

export async function getUsersService(screenGridId, configSchema) {
  const body = {
    columns: ['id', 'firstName:firstname', 'lastName:lastname', 'userId:user_account_id'],
    screenGridId,
    schema: configSchema,
    table: 'mbd_users',
    orderCol: 'id',
    order: 'asc',
  };
  const { data, errors } = await postRequest('/api/records', body);

  if (errors) {
    return { errors };
  }

  return data;
}
